var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChevronDown = function SvgChevronDown(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-24": 14,
    viewBox: "0 0 14 7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#chevron-down_svg__a)",
    d: "M6.746 6.516a.78.78 0 0 1-.48-.17l-6-5a.766.766 0 1 1 1-1.16l5.48 4.6 5.52-4.6a.765.765 0 1 1 1 1.16l-6 5a.78.78 0 0 1-.52.17"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "chevron-down_svg__a",
    x1: -1.105,
    x2: 14.222,
    y1: 3.258,
    y2: 3.258,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#14D9C5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8E44EC"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChevronDown);
export default ForwardRef;